export enum MARK_METHOD {
    WEB_DESKTOP = 1,
    APP = 2,
    EQUIPOS = 3,
    WEB_MOBILE = 4,
    FACE_ID = 5,
    FINGERPRINT = 6,
    PASSWORD = 7,
    CARD = 8,
    SOLICITUD = 9
  }